/** SA-112: schema-typed display of a parameter value (LockedRow + the
 * default hints). Localized maps pick the deployment language first
 * (languages[0]), then en, then the first defined variant — the EN-first
 * admin-surface convention, deployment-language preferred. */
import type { WorkflowManifestParameterSchema } from '@/types/workflowConfig'

function pickLang(map: Record<string, unknown>, languages: string[]): unknown {
  const first = Object.values(map).find((v) => v != null)
  return map[languages[0]] ?? map.en ?? first
}

export function formatParamValue(
  value: unknown,
  schema: WorkflowManifestParameterSchema,
  languages: string[],
): string {
  if (value === null || value === undefined) return '—'
  if (schema.type === 'localized_text') {
    const picked = pickLang(value as Record<string, unknown>, languages)
    return picked === null || picked === undefined ? '—' : String(picked)
  }
  if (schema.type === 'localized_string_list') {
    const picked = pickLang(value as Record<string, unknown>, languages)
    return Array.isArray(picked) && picked.length > 0 ? picked.join(', ') : '—'
  }
  if (schema.type === 'string_list') {
    return Array.isArray(value) && value.length > 0 ? value.join(', ') : '—'
  }
  if (schema.type === 'boolean') return value ? 'on' : 'off'
  return String(value)
}
